import { asm } from './asm';

export const en = {
  asm,
};
